<template>
  <div>
    <div
      class="relative flex items-center justify-between gap-3 pl-2.5 pr-5 pt-5 pb-2"
    >
      <div class="min-w-0">
        <div class="text-[14px] font-medium leading-[18px] text-gray-800">
          {{ title }}
        </div>
        <Skeleton v-if="loading" class="mt-1 h-[13px] w-[60px]" />
        <div v-else class="text-[14px] leading-[18px] text-gray-500">
          {{ formatNumber(total ?? 0) }}
          {{ total === 1 ? 'result' : 'results' }}
        </div>
      </div>
      <Button
        v-if="!loading && total"
        variant="primary"
        size="md"
        @click="$emit('view-all')"
      >
        View all
      </Button>
    </div>

    <template v-if="loading">
      <SearchRowSkeleton v-for="n in 3" :key="n" />
    </template>
    <div
      v-else-if="!total"
      class="relative px-2.5 py-[18px] text-[14px] leading-[18px] text-gray-500"
    >
      {{ emptyLabel }}
    </div>
    <slot v-else />
  </div>
</template>

<script setup lang="ts">
import { Button, Skeleton } from '@dacr/library'
import { formatNumber } from '@/shared/utils/number'
import SearchRowSkeleton from '@/features/search/components/mobile/SearchRowSkeleton.vue'

defineProps<{
  title: string
  total?: number
  loading: boolean
  emptyLabel: string
}>()

defineEmits<{ 'view-all': [] }>()
</script>
